import { _baseGetFetch, _basePostFetch } from './baseFetch'

export const getDeviceSpareParts = (queryParams) => {
  return _baseGetFetch(`/spareparts`, { ...queryParams, limit: 10 })
}

export const getDeviceSparePartsModels = () => {
  return _baseGetFetch(`/spareparts/models`)
}

export const getDeviceSparePartsTotalCount = (queryParams) => {
  return _baseGetFetch(`/spareparts/total-record`, queryParams)
}

export const postSparePartsRequestMissingItem = (body) => {
  return _basePostFetch(`/spareparts/requests/missing-items`, body)
}

export const postSparePartsRequestReview = (body) => {
  return _basePostFetch(`/spareparts/requests/review`, body)
}

